var cifIt = ["301 201", "<g fill='none'><path fill='#009246' d='M.5.5h100v200H.5z'/><path fill='#FFF' d='M100.5.5h100v200h-100z'/><path fill='#CE2B37' d='M200.5.5h100v200h-100z'/></g>"];

export { cifIt };

